import React from "react";
import image1 from "@assets/digital-illustration-section_2_1.svg";
import image2 from "@assets/digital-illustration-section_2_2.svg";
import image3 from "@assets/digital-illustration-section_2_3.svg";

const FeaturesOverviewSection: React.FC = () => {
  return (
    <section className="2xl:h-[calc(100vh-96px)] md:h-[calc(100vh-75px)] pt-12 2xl:pt-24 pb-8 md:pb-[8rem] w-full flex flex-col items-center justify-center px-5 md:px-24 bg-white snap-start transition-all duration-700">
      <div className="w-full text-center max-w-7xl sm:mb-0 2xl:mb-16 h-full md:h-auto">
        <div className="w-full">
          <h2 className="text-base md:text-2xl 2xl:text-3xl font-semibold text-gray-800 mb-4 md:mb-12 2xl:mb-20 text-center">
            Designed for change-makers,
            <br />
            built for real-world impact
          </h2>
        </div>
        <div className="flex flex-col md:flex-row items-center md:items-start w-full space-y-6 md:space-y-0">
          <div className="md:w-1/3 w-full">
            <img
              src={image1}
              alt="icon1"
              className="mx-auto mb-3 md:mb-8 h-[90px] md:h-[160px]"
            />
            <p className="font-semibold mb-2 text-sm md:text-base">
              Collaboration that works.
            </p>
            <p className="text-gray-600 text-xs md:text-base">
              One shared space for NGOs and
              <br />
              foundations—no silos, no scattered files.
            </p>
          </div>
          <div className="md:w-1/3 w-full">
            <img
              src={image2}
              alt="icon2"
              className="mx-auto mb-3 md:mb-8 h-[70px] md:h-[140px]"
            />
            <p className="font-semibold mb-2 text-sm md:text-base pt-[20px]">
              Beyond reporting.
            </p>
            <p className="text-gray-600 text-xs md:text-base">
              Automate progress updates, detect
              <br />
              anomalies and shape stronger narratives
              <br />
              with smart, data-driven insights.
            </p>
          </div>
          <div className="md:w-1/3 w-full">
            <img
              src={image3}
              alt="icon3"
              className="mx-auto mb-3 md:mb-8 h-[70px] md:h-[140px]"
            />
            <p className="font-semibold mb-2 text-sm md:text-base pt-[20px]">
              Your data. Your rules.
            </p>
            <p className="text-gray-600 text-xs md:text-base">
              Total control with secure, flexible access—
              <br />
              always on your terms.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesOverviewSection;
